var EntryLocation;
(function (EntryLocation) {
    EntryLocation["Start"] = "Start";
    EntryLocation["Middle"] = "Middle";
    EntryLocation["End"] = "End";
})(EntryLocation || (EntryLocation = {}));

export { EntryLocation };
//# sourceMappingURL=entry-location.js.map
